export const MARKETPLACE_API_URL = "https://dmarketapi.repositpower.com";
export const APP_VERSION = "v1.7-web";
export const GOOGLE_ANALYTICS_KEY = "UA-00000000-1";
export const TURNSTILE_SITE_KEY = "0x4AAAAAAAEbho5dyjhb-djk";



// WEBPACK FOOTER //
// ./src/dev-config.js